<div [style.padding]="Padding"
     class="stack-panel-container {{StackPanelOrientation}} {{StackPanelHorizontalAlignment}} {{BackgroundClass}}">
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/panels/stack-panel/stack-panel.html